import { Api } from '@axiom/ui';
import type { Candidate, DsMatchSummary, Opportunity } from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';

class MatchSummaryApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiEnvoyUrl,
    });
  }

  readMatchSummary({
    opportunityId,
    candidateId,
  }: {
    opportunityId: Opportunity['id'];
    candidateId: Candidate['id'];
  }) {
    return super.read<{
      data: { dsMatchSummary: DsMatchSummary | null };
    }>({
      method: 'GET',
      endpoint: `/opportunities/${opportunityId}/candidates/${candidateId}/matchSummary`,
    });
  }

  async createMatchSummaryRequest({
    opportunityId,
    candidateId,
  }: {
    opportunityId: Opportunity['id'];
    candidateId: Candidate['id'];
  }) {
    return super.write<Record<string, never>>({
      method: 'POST',
      endpoint: `/opportunities/${opportunityId}/candidates/${candidateId}/matchSummaryRequest`,
    });
  }

  async refreshMatchSummary({
    opportunityId,
    candidateId,
  }: {
    opportunityId: Opportunity['id'];
    candidateId: Candidate['id'];
  }) {
    return super.invalidate(
      `/opportunities/${opportunityId}/candidates/${candidateId}/matchSummary`
    );
  }
}

export const MatchSummaryApi = new MatchSummaryApiClass();
